import EventBox from "./EventBox.jsx";

function EventsTable({ events }) {
    // Copy before sorting so calendar data and React Query's cache stay untouched.
    const sortedEvents = [...events].sort((a, b) =>
        Number(b.is_sponsored === true) - Number(a.is_sponsored === true) ||
        new Date(a.startDatetime) - new Date(b.startDatetime)
    );
    return (
        <div className="mx-auto w-full max-w-4xl px-2 sm:px-4">
            {events.length === 0 ? (
                <div className="flex items-center justify-center py-12">
                    <p className="text-gray-500 italic text-lg">No recorded events on this date</p>
                </div>
            ) : (
                <div className="event-list">
                    {sortedEvents.map((event) => (
                        <EventBox key={event.id} event={event} />
                    ))}
                </div>
            )}
        </div>
    );
}

export default EventsTable;
